import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  host: {
    class: 'flex min-h-0 flex-1 flex-col',
  },
  imports: [RouterLink],
  selector: 'avs-uc-monitoring-not-connected',
  standalone: true,
  templateUrl: './uc-monitoring-not-connected.component.html',
})
export class UcMonitoringNotConnectedComponent {
  readonly canConfigure = input.required<boolean>();
}
